import { Menu, Item } from './Menu';
Menu.displayName = "MenuBase";
Item.displayName = "Menu.Item";
export { Menu as default, Item };